import { IconProps } from "../interface";
import { IconColours } from "../interface";

const Link = ({
    title = "link",
    size,
    className,
    ariaHidden,
    type,
    colour = IconColours.black,
    secondaryColour = IconColours.white,
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        role="img"
        aria-hidden={ariaHidden}
        focusable={!ariaHidden}
    >
        <title>{title}</title>
        {type === "outlined" ? (
            <rect width="24" height="24" rx="12" fill={secondaryColour} />
        ) : null}
        <path
            data-testid="path"
            d="M9.97382 14.4521C10.3535 14.8333 10.9692 14.8333 11.349 14.4521C11.7287 14.0707 11.7287 13.4525 11.349 13.0712L10.6614 12.3808C9.52221 11.237 9.52221 9.38229 10.6614 8.23838L14.0752 4.81071C15.2143 3.66682 17.0614 3.66682 18.2007 4.81073C19.34 5.95466 19.34 7.80934 18.2008 8.95325L16.8501 10.3095C16.4703 10.6909 16.4703 11.309 16.8501 11.6903C17.2298 12.0717 17.8456 12.0717 18.2253 11.6903L19.576 10.3341C21.4747 8.42751 21.4747 5.33639 19.5759 3.42989C17.6771 1.52339 14.5987 1.52335 12.7 3.42988L9.28626 6.85754C7.38752 8.76407 7.38752 11.8551 9.28626 13.7617L9.97382 14.4521ZM14.0262 9.54797C13.6465 9.16667 13.0308 9.16667 12.6511 9.54797C12.2713 9.92931 12.2713 10.5475 12.6511 10.9288L13.3386 11.6192C14.4778 12.7631 14.4778 14.6178 13.3386 15.7616L9.92491 19.1892C8.78566 20.3332 6.93855 20.3332 5.79928 19.1892C4.66002 18.0454 4.65999 16.1906 5.79922 15.0468L7.14994 13.6905C7.52968 13.3092 7.52967 12.6909 7.14992 12.3097C6.77017 11.9283 6.15448 11.9284 5.77473 12.3097L4.42401 13.666C2.52527 15.5725 2.52536 18.6636 4.4241 20.5702C6.32284 22.4766 9.40133 22.4767 11.3001 20.5702L14.7137 17.1424C16.6125 15.2359 16.6125 12.1448 14.7137 10.2383L14.0262 9.54797Z"
            fill={colour}
        />
    </svg>
);

export default Link;
